<template>
    <section>
        <a class="link" @click="toggleButton" role="button">
            Gráfico Ejecución de Metas
            <i class="fas fa-angle-down" v-if="!active"></i>  
            <i class="fas fa-angle-up" v-else></i>  
        </a>
        <div class="container-tree" style="margin-bottom: 1em;">
            <div :class="`tree-chart${active && ' active' || ''}`">
                <div>
                    <highcharts ref="highchartsRef" :options="options" ></highcharts>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Highcharts from 'highcharts';
import { Chart } from 'highcharts-vue';
import loadSankey from 'highcharts/modules/sankey.js';
import loadOrganization from 'highcharts/modules/organization.js';
import loadExporting from 'highcharts/modules/exporting.js';
loadSankey(Highcharts);
loadOrganization(Highcharts);
loadExporting(Highcharts);

export default {
    name: "Tree",
    components: {
        highcharts: Chart,
    },
    props: {
        program: {
            type: Object,
            default: () => {}
        },
        year: {
            type: Number,
            default: () => new Date().getFullYear()
        }
    },
    methods: {
        toggleButton() {
            this.active = !this.active;
        },
        getHeight() {
            var nActivities = 0
            this.program.products.forEach( product => { nActivities += product.activities.length } );
            return nActivities * 115;
        },        
        getData() {
            const data = [];
            this.program.products.forEach( product => {
                data.push([this.program.code, product.code]);
                product.activities.forEach( activity => {
                    data.push([product.code, activity.code])
                    data.push([activity.code, `results_${activity.code}`])
                })
            });
            return data;
        },
        getNodePadding() {
            return 15;
        },
        
        getOffset(height, nProducts, nodePadding, nodeHeight, nBeforeSiblings, nChildren, nBeforeNephews) {
            const topPadding = ( height - ( nProducts - 1 ) * nodePadding - nProducts * nodeHeight ) / 2 + nBeforeSiblings * ( nodeHeight + nodePadding );
            const childrenPosition = nBeforeNephews * ( nodeHeight + nodePadding );
            const parentPosition = ( ( nChildren * nodeHeight + ( nChildren - 1 ) * nodePadding ) - nodeHeight ) / 2;
            const offset = childrenPosition - topPadding + parentPosition;
            return offset;
        },
        getNodes() {
            const nodes = [];
            const nProducts = this.program.products.length;
            const height = this.getHeight();
            const nodePadding = this.getNodePadding()
            var nActivities = 0;
            this.program.products.forEach( product => { nActivities += product.activities.length } );
            const nodeHeight = ( height - ( nActivities - 1 ) * nodePadding ) / nActivities;
            const colors = [ 
                //{    productColor: '#FFADAD', activityColor: '#FFC2C2', resultColor: '#FF8A8A' },
                //{    productColor: '#FFD6A5', activityColor: '#FFE3C2', resultColor: '#FFCA8A' },
                //{    productColor: '#FDFFB6', activityColor: '#FEFFD6', resultColor: '#FBFF8A' },
                //{    productColor: '#CAFFBF', activityColor: '#DDFFD6', resultColor: '#9DFF8A' },
                //{    productColor: '#9BF6FF', activityColor: '#ADF8FF', resultColor: '#8AF5FF' },
                //{    productColor: '#A0C4FF', activityColor: '#C2D9FF', resultColor: '#8AB7FF' },
                //{    productColor: '#BDB2FF', activityColor: '#DCD6FF', resultColor: '#A899FF' },
                //{    productColor: '#FFC6FF', activityColor: '#FFC6FF', resultColor: '#FFADFF' },

                {    productColor: '#CAFFBF', activityColor: '#FEFFD6', resultColor: '#C2D9FF' },
                {    productColor: '#FDFFB6', activityColor: '#FFE3C2', resultColor: '#C2D9FF' },
                {    productColor: '#FDFFB6', activityColor: '#FFE3C2', resultColor: '#C2D9FF' },
                {    productColor: '#FDFFB6', activityColor: '#FFE3C2', resultColor: '#C2D9FF' },
                {    productColor: '#FDFFB6', activityColor: '#FFE3C2', resultColor: '#C2D9FF' },
                {    productColor: '#FDFFB6', activityColor: '#FFE3C2', resultColor: '#C2D9FF' },
            ]
            var nBeforeNephews = 0;
            nodes.push({
                id: this.program.code,
                name: this.program.code,
                title: this.program.title,
                color: colors[0].productColor,
            })
            this.program.products.forEach((product, index) => {                
                nodes.push({
                    id: product.code,
                    name: product.code,
                    title: product.title,
                    offset: this.getOffset(height, nProducts, nodePadding, nodeHeight, index, product.activities.length, nBeforeNephews),
                    color: colors[index + 1].productColor,
                })
                nBeforeNephews += product.activities.length;
                product.activities.forEach( activity => {
                    nodes.push({
                        id: activity.code,
                        name: activity.code,
                        title: activity.title,
                        color: colors[index + 1].activityColor,
                    });
                    nodes.push({
                        id: `results_${activity.code}`,
                        name: activity.indicator.name,
                        //name: activity.indicator.code,
                        //title: activity.results && activity.results.length ? activity.results[0].type : "Resultados",
                        title: `(${activity.results && activity.results.length ? activity.results.filter( r => r.bundle_id == 'MAIN').map( r => r.quantity ).reduce( (a, b) => a + b, 0 ) : "0"})`,
                        results: activity.results.filter(result => result.bundle_id == 'MAIN').length,
                        color: activity.results && activity.results.length ? colors[index + 1].resultColor : 'transparent',
                        width: 100
                    });                
                })
            });
            return nodes;
        }
    },
    data () {
        return { 
            active: true,
            options: {
                chart: {
                    height: this.getHeight() + 68,
                    backgroundColor: 'white',
                },
                title: {
                    text: `Ejecución de Metas PP ${this.program.code} - ${this.year}`,
                    style: {
                        fontFamily: 'Helvetica',
                        fontSize: '23px'
                    }
                },
                series: [
                    {
                        type: 'organization',
                        name: `PPR ${this.program.code}`,
                        keys: ['from', 'to'],
                        data: this.getData(),
                        levels: [
                            {
                                level: 0,
                                color: '#8e9aaf',
                            },
                            {
                                level: 1,
                                color: '#efd3d7',
                            },
                            {   
                                level: 2,                               
                                color: '#dee2ff',
                            }
                        ],
                        nodes: this.getNodes(),
                        colorByPoint: false,
                        dataLabels: {
                            color: 'black',
                        },
                        borderColor: 'black',
                        nodePadding: this.getNodePadding(),
                        linkRadius: 4,
                        linkLineWidth: 2,
                        nodeWidth: 180                    
                    }
                ],
                tooltip: {
                    outside: true,
                },
                exporting: {
                    allowHTML: true,
                    sourceWidth: 1200,
                    sourceHeight: this.getHeight()
                }
            }
        }
    }
}
</script>
<style scoped>
    .highcharts-figure, .highcharts-data-table table {
        min-width: 360px; 
        max-width: 800px;
        margin: 1em auto;
    }
    .highcharts-data-table table {
        border-collapse: collapse;
        border: 1px solid #EBEBEB;
        margin: 10px auto;
        text-align: left !important;
        width: 100%;
        max-width: 500px;
    }
    .highcharts-data-table caption {
        padding: 1em 0;
        font-size: 1.2em;
        color: #555;
    }
    .highcharts-data-table th {
        font-weight: 600;
        padding: 0.5em;
    }
    .highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {
        padding: 0.5em;
    }
    .highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {
        background: #f8f8f8;
    }
    .highcharts-data-table tr:hover {
        background: #f1f7ff;
    }

    #container h4 {
        text-transform: none;
        font-size: 14px;
        font-weight: normal;
    }
    #container p {
        font-size: 13px;
        line-height: 16px;
    }

    @media screen and (max-width: 600px) {
        #container h4 {
            font-size: 2.3vw;
            line-height: 3vw;
        }
        #container p {
            font-size: 2.3vw;
            line-height: 3vw;
        }
    }
    .container-tree{
        width: 100%;
    }
    @media screen and (max-width: 1200px){
        .container-tree{
            overflow-x: scroll;
        }
    }
    .tree-chart {
        width: 800px;
        transform: scale(1);
        visibility: hidden;
        opacity: 0;
        transition: .2s all;
        height: 0;
    }
    .tree-chart.active {
        visibility: visible;
        opacity: 1;
        height: auto;
    }
</style>